import { gql } from '@apollo/client';

const schema = {
  get: {
    name: 'attributeCategory',
    serviceName: 'shopadmin',
    query: gql`
      query attributeCategory($ids: [String]) {
        attributeCategory(ids: $ids) {
          data {
            title
            description
          }
        }
      }
    `,
  },
  update: {
    name: 'updateAttributeCategory',
    serviceName: 'admin',
    query: gql`
      mutation updateAttributeCategory($ids: [String]!, $title: String, $description: String) {
        updateAttributeCategory(ids: $ids, title: $title, description: $description) {
          influenced_count
          messages
        }
      }
    `,
  },
};

export default schema;
